<template>
  <div class="cardItem fvlu" @click.stop>
    <div class="imgBox">
      <van-image lazy-load :src="thumb" alt="图片缺失">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" color="#3088c5" />
        </template>
      </van-image>
    </div>
    <div class="contentBox fhlud">
      <div><slot name="title"></slot></div>
      <slot name="price"></slot>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { addEightHour } from '@/util'

export default {
  props: ['data', 'gsCode', 'customerCarId', 'thumb'],
  emits: ['link'],
  setup(props, { emit }) {
    let { thumb } = toRefs(props)
    const state = reactive({
      thumb
    })
    let toDetail = data => {
      emit('link', data)
    }

    return {
      ...toRefs(state),
      toDetail,
      addEightHour
    }
  }
}
</script>
<style lang="scss" scoped>
.cardItem {
  padding: 8px 16px;
  color: #666666;
  text-align: left;
}
.contentBox {
  min-height: 88px;
}
.imgBox {
  margin-right: 20px;
  width: 88px;
  height: 88px;
  text-align: center;
  line-height: 88px;
  overflow: hidden;
  .van-image img {
    display: inline-block;
    width: 88px;
    height: 88px;
    border-radius: 0;
  }
}
</style>
